(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('AlarmsListController', AlarmsListController);
    

    AlarmsListController.$inject = [
		'$templateCache', 'alarmaService', '$scope', '$rootScope', '$state', '$filter'
    ];

    

	function AlarmsListController($templateCache, alarmaService, $scope, $rootScope, $state, $filter){
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
            var templates = {
                accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
                rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html')
            };

        var row = { 
            'date' : '02/01/2017 17:34:31', 
            'type' : 'Zona', 
            'name' : 'Primera alarma', 
            'description': 'Lorem ipsum dolor sit amet consecteur adipiscing elit', 
            'entity': 'Vehículo', 
            'vehicle' : '001 - 0000AA', 
            'driver' : 'Lacasito', 
            'address' : 'click aquí',  
            'actions' : 'eliminar'
        };
        
        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
			rowTemplate: templates.rowTemplate,

            columnDefs: [

                {
                    field: 'fecha',
                    displayName: 'Fecha',
                    minWidth: 135,
                    maxWidth: 150,
                    resizable: true
                },

                {
                    name: 'type',
                    displayName: 'Tipo',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    field: 'name',
                    displayName: 'Nombre',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                     field: 'descripcion',
                     displayName: 'Descripción',
                },

                {
                    field: 'entity',
                    displayName: 'Entidad',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    field: 'vehicle',
                    displayName: 'Vehículo',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    field: 'flota.operario.nombre',
                    displayName: 'Operario',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    field: 'address',
                    displayName: 'Dirección',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate
                }

             ],
             data: 'gridData',
        };

        vm.goToEdit = goToEdit;

        (function () {
            loadData();
        })();

        function goToEdit(alarma) {
			$state.go('flota.alarmas.editar', { 'id': alarma.alarmaId });
        }
        
        function loadData(){
			alarmaService.getList().then(function (result) {
				$scope.gridData = result.data.list;
				vm.gridData = result.data.list;
			});
        }
    }

})();

